module.exports = __webpack_public_path__ + "static/media/125.b21a4776.jpg";